import urljoin from 'url-join';
import { portalApi } from './index.api';

const SPECTRAL_DATA = "spectraldata";
export const spectralDataApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchSpectralMetaData: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(SPECTRAL_DATA, projectId),
				method: 'GET',
			})
		}),
		fetchSpectralUrl: builder.query({
			query: (projectId) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(SPECTRAL_DATA, projectId, 'download'),
				method: 'GET',
			})
		}),
		
	}),
});

export const {
	useFetchSpectralMetaDataQuery,
	useFetchSpectralUrlQuery
} = spectralDataApi;

/* 
√ GET /api/v1/spectraldata/{projectId}
√ GET /api/v1/spectraldata/{projectId}/download
*/